import React from "react";
import { ConnectedService } from "../components/ConnectedService";
import { Message } from "../locale/Message";
import { connect } from "react-redux";

class Services extends React.Component {
  render() {
    const { lang, customer } = this.props;
    const services = (customer?.clientServices || []).filter(
      ({ alias }) => alias !== "msg" && alias !== "b2b_fwa_selfcare",
    );
    return (
      <div className="submenu bg-white">
        <ul className="main-tabs list-unstyled d-xl-flex align-content-xl-center mb-0">
          <li className="mb-3 mb-xl-0">
            <a className="active pr-5 font-weight-bolder" href="#tab1">
              {Message.enabledServices[lang]}
            </a>
          </li>
        </ul>
        <section className="table-header bg-white">
          <div className="connected-services row">
            {services.map((service) => (
              <ConnectedService
                lang={lang}
                key={service.id}
                service={service}
              />
            ))}
          </div>
        </section>
      </div>
    );
  }
}

export default connect((state) => ({
  lang: state.lang,
  customer: state.customer,
}))(Services);
